import { CreateBusinessProcessUseCase } from '@/data/use-cases/projects-use-cases.js';
import { CreateProjectUseCase } from '@/data/use-cases/projects-use-cases.js';
import { DeleteBusinessProcessUseCase } from '@/data/use-cases/projects-use-cases.js';
import { DeleteProjectDocumentUseCase } from '@/data/use-cases/projects-use-cases.js';
import { GetProjectDocumentDownloadUrlUseCase } from '@/data/use-cases/projects-use-cases.js';
import { ListActiveBusinessProcessesUseCase } from '@/data/use-cases/projects-use-cases.js';
import { ListBusinessProcessesUseCase } from '@/data/use-cases/projects-use-cases.js';
import { ListProjectDocumentsUseCase } from '@/data/use-cases/projects-use-cases.js';
import { ListProjectUsersUseCase } from '@/data/use-cases/projects-use-cases.js';
import { LoadMyProjectsUseCase } from '@/data/use-cases/projects-use-cases.js';
import { LoadProjectByIdUseCase } from '@/data/use-cases/projects-use-cases.js';
import { LoadProjectsUseCase } from '@/data/use-cases/projects-use-cases.js';
import { ToggleBusinessProcessUseCase } from '@/data/use-cases/projects-use-cases.js';
import { UpdateBusinessProcessUseCase } from '@/data/use-cases/projects-use-cases.js';
import { UpdateProjectStatusUseCase } from '@/data/use-cases/projects-use-cases.js';
import { UpdateProjectUseCase } from '@/data/use-cases/projects-use-cases.js';
import { UploadProjectDocumentUseCase } from '@/data/use-cases/projects-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { ProjectRepositoryImpl } from '@/infra/repositories/project-repository-impl.js';
import { ProjectController } from '@/presentation/controllers/project-controller.js';

export const makeProjectController = (httpClient: FetchHttpClient): ProjectController => {
    const repository = new ProjectRepositoryImpl(httpClient);
    return new ProjectController(
        new LoadProjectsUseCase(repository),
        new LoadProjectByIdUseCase(repository),
        new CreateProjectUseCase(repository),
        new UpdateProjectUseCase(repository),
        new UpdateProjectStatusUseCase(repository),
        new LoadMyProjectsUseCase(repository),
        new ListBusinessProcessesUseCase(repository),
        new ListActiveBusinessProcessesUseCase(repository),
        new ListProjectUsersUseCase(repository),
        new CreateBusinessProcessUseCase(repository),
        new UpdateBusinessProcessUseCase(repository),
        new ToggleBusinessProcessUseCase(repository),
        new DeleteBusinessProcessUseCase(repository),
        new ListProjectDocumentsUseCase(repository),
        new UploadProjectDocumentUseCase(repository),
        new DeleteProjectDocumentUseCase(repository),
        new GetProjectDocumentDownloadUrlUseCase(repository)
    );
};
